<script setup>
import { Notifications } from '@codinglabsau/ui'
</script>

<template>
  <div class="flex min-h-screen flex-col bg-stone-100 font-sans antialiased">
    <slot />

    <Notifications
      class="z-50"
      :info="$page.props.info"
      :success="$page.props.success"
      :warning="$page.props.warning"
      :errors="$page.props.errors"
    />
  </div>
</template>
